export const formatCurrency = (cents: number | null | undefined): string => {
  if (!cents) return '-';
  return `$${(cents / 100).toFixed(2)}`;
};

/**
 * Both `marginOverridePercentage` and `tenantMarginPercentage` are decimals
 * in the 0-1 range (e.g. 0.06 for 6%), matching what the API stores.
 */
export const calculateMarginChargeRate = (
  minimum: number | null | undefined,
  marginOverridePercentage: number | null | undefined,
  tenantMarginPercentage: number | null | undefined,
): number | null => {
  if (!minimum) return null;
  const margin = marginOverridePercentage ?? tenantMarginPercentage ?? 0;
  return minimum + Math.round(minimum * margin);
};
